module.exports = __webpack_public_path__ + "static/media/favorite.2eafc6c7.svg";